import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgClass } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-bottom-sheet',
    templateUrl: './bottom-sheet.component.html',
    styleUrl: './bottom-sheet.component.scss',
    imports: [MatIconModule, NgClass],
    animations: [
        trigger('bottomSheetAnimation', [
            state('closed', style({
                transform: 'translateY(100%)',
            })),
            state('open', style({
                transform: 'translateY(0)',
            })),
            transition('closed <=> open', [
                animate('300ms ease-in-out')
            ])
        ]),
    ]
})
export class BottomSheetComponent implements OnChanges {
  
  @Input({required: true}) sheetID!: string; // Importante passar um ID para o sheet e atribuir no HTML a div de sheet. Notei que ao ter dois sheets instanciados, a função de clickedOutsideBottomSheet não sabe qual é qual.
  @Input({required: true}) title!: string;
  @Input() show = false;
  @Input() hideCloseButton = false;

  @Output() showEmitter = new EventEmitter<boolean>();

  ngOnChanges(changes: SimpleChanges): void {
    this.show = changes['show'].currentValue;
  }

  protected handleClose = () => {
    this.showEmitter.emit(false);
  }

  // Lida com o click fora do bottom sheet dos ramos. Se estiver aberto e o usuário clicar fora, devemos fechar. 
  protected clickedOutsideBottomSheet = (event: Event) => {   
    event.stopPropagation();
    
    if (this.show) {
      const bottomSheetEL = document.getElementById(this.sheetID);
      const clickedEl = event.target as HTMLElement;

      const clickedInside = bottomSheetEL.contains(clickedEl);
      
      if (!clickedInside) {
        this.handleClose();
      }
    }
  }
}
